import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserMenuComponent } from './user-menu.component';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MaterialModule } from 'src/app/material/material.module';
import { PrivacyModule } from 'src/app/privacy/privacy.module';
import { TFAuthDialogComponent } from './tf-auth-dialog/tf-auth-dialog.component';


@NgModule({
    declarations: [UserMenuComponent, TFAuthDialogComponent],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule,
        MaterialModule,
        RouterModule,
        PrivacyModule
    ],
    exports: [
        UserMenuComponent,
        TFAuthDialogComponent
    ]
})
export class UserMenuModule { }
